import { Auth0Provider } from '@auth0/auth0-react'
import Auth0ChildInjector from './Auth0ChildInjector';



const Auth0Injector = ({ authConfiguration, children }) => {
  if (!authConfiguration) {
    return children
  }
  let redirectUri = authConfiguration.redirectUri
  if (!redirectUri) {
    redirectUri = window.location.origin
  }
  let scope = authConfiguration.scope
  if (!scope) {
    scope = 'openid profile email read:current_user offline_access'
  }
  return (
    <Auth0Provider
      domain={authConfiguration.domain}
      clientId={authConfiguration.clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        scope:scope,
        audience:authConfiguration.audience
      }}
      cacheLocation={authConfiguration.cacheLocation || 'localstorage'}
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
    >
        <Auth0ChildInjector>
            {children}
        </Auth0ChildInjector>      
    </Auth0Provider>
  )
}
export default Auth0Injector
